import './App.css';
import Home from './pages/Home.jsx';
import About from './pages/About.jsx';
import News from './pages/News.jsx';
// import Contact from './pages/Contact.jsx'
import Covid from './pages/Covid.jsx'
import Footer from './pages/Footer.jsx'
import NewsHeading from './pages/NewsHeading';
import Team from './pages/Team.jsx';

function App() {
  return (
    <div className="App" class="bg-green-100">
      <Home/>
      <NewsHeading/>
      <News/>
      <About/>
      <Covid/>
      <Team/>
      {/* <Contact/> */}
      <Footer/>
    </div>
  );
}

export default App;
